import React from 'react'
import Ieee_banner from '../Ieee_banner/Ieee_banner'
import day_1 from "./schedule.pdf"
// import day_2 from "./QR_codes.pdf"

function Shedule() {
  return (
    <div className="container my-5">
    <div className="row">
      <div className="col-sm-6 mb-3 mb-sm-0">
            <div className="card border-0">
              <div className="card-body">
                <h1 className="card-title border-bottom">Program Schedule</h1>

                {/* <h3 className="card-title">Day-wise Program Schedule</h3> */}
                <div class="ratio ratio-1x1 my-5" >
                    <iframe class="embed-responsive-item" src={day_1} allowfullscreen></iframe>
                </div>
                
              </div>
            </div>
          </div>

          <Ieee_banner />


          
    </div>
  </div>
  )
}

export default Shedule